import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';
import GreenTick from '../../../../images/rewampimages/greentick.png';
import UnverifiedLogo from '../../../../images/rewampimages/unverifiedCross.png';
import { getAllcloudDataByUserID, uploadAllcloudcompleteFlow, saveOrUpdateAllCloudDetail } from "../AdminActionCreator.component";
import moment from "moment";
import Loader from '../../../presentationals/Loader/Loader.component'
import Popup from '../../../presentationals/Popup/Popup.component'

const customInputStyle = {
    background: "#fff",
    border: '1px solid #ccc',
    color: '#000',
    width: '100%'
}

const ChecklistFresh = ({ userDetail }) => {
    const [data, setData] = useState({
        customerId: "",
        financeId: "",
        agreementNo: "",
        status: "",
        stage: "",
        error:"",
        leadDetailId:"",
        leadIndexNo:"",
    })
    const [view, setView] = useState("list")
    const [dataSet, SetData] = useState('');
    const [loading, setLoading] = useState(true);
    const [loader, setLoader] = useState(false);
    const [popup, setpopup] = useState({ show: false, popupStatus: "" });

    const handleView = (type) => {
        if (type == "edit") {
            setData({
                customerId: dataSet?.customerId || "",
                financeId: dataSet?.financeId || "",
                agreementNo: dataSet?.agreementNo || "",
                status: dataSet?.status || "",
                stage: dataSet?.stage || "",
                error: dataSet?.error || "",
                leadDetailId: dataSet?.leadDetailId || "",
                leadIndexNo: dataSet?.leadIndexNo || "",
            })
        }
        if (type == "list") {
            setData({
                customerId: "",
                financeId: "",
                agreementNo: "",
                status: "",
                stage: "",
                error: "",
                leadDetailId: "",
                leadIndexNo: "",
            })
        }
        setView(type)
    }

    useEffect(() => {
        getapis()
    }, [userDetail]);

    const getapis = () => {
        setLoading(true)
        getAllcloudDataByUserID(userDetail?.userId, callBack => {
            console.log(callBack);
            setLoading(false);
            if (callBack?.status == 200 && callBack?.message == "success") {
                SetData(callBack?.data);
            } else {
                SetData("");
            }
        });
    }

    const handleUpload = () => {
        setLoader(true)
        uploadAllcloudcompleteFlow(userDetail?.userId, callBack => {
            setLoader(false)
            if (callBack?.status == 200 && callBack?.message == "success") {
                setpopup({ show: true, popupStatus: "Data Uploaded Successfully" })
            } else {
                setpopup({ show: true, popupStatus: "Flow failed" })
            }
            removePopup()
        })
    }

    const closePopup = () => {
        setpopup({ show: false, popupStatus: "" })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

    const handleEmpty = (value) => {
        console.log(value)
        if (value == null || value == undefined || value == "") {
            return ""
        }
        return value
    }

    const handleInput = (e, type) => {
        const { value } = e.target;
        setData((prev) => ({
            ...prev,
            [type]: value
        }))
    }

    const handleSave = () => {
        const obj = {
            ...dataSet,
            customerId: data?.customerId || "",
            financeId: data?.financeId || "",
            agreementNo: data?.agreementNo || "",
            status: data?.status || "",
            stage: data?.stage || "",
            error: data?.error || "",
            leadDetailId: data?.leadDetailId || "",
            leadIndexNo: data?.leadIndexNo || "",
        }
        setLoading(true)
        saveOrUpdateAllCloudDetail(obj, callBack => {
            console.log("call", callBack)
            setLoading(false)
            setView("list")
            getapis()
        })
    }

    return (
        <>
            {
                loader ? < Loader /> : ""
            }
            {
                popup?.show ? <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} /> : ""
            }
            <div className="details-new">
                <div className="phocket-table-ops">
                    <div style={{ padding: '10px', display: 'flex', justifyContent: 'space-between' }}>

                        <h4>
                            {
                                view == "edit" ?
                                    <button onClick={() => handleView("list")}><i className="fa fa-arrow-left"></i></button>
                                    : ''}
                            All Cloud
                            {
                                view == "list" ?
                                    <button onClick={() => handleView("edit")}><i className="fa fa-edit"></i></button>
                                    : ''}
                        </h4>
                        <button className="btn btn-primary" onClick={() => handleUpload()}><i className="fa fa-upload"></i> &nbsp;Upload</button>
                    </div>

                    <table className="phocket-table-ops" style={{ width: '100%' }}>
                        {
                            loading ?

                                <tbody>
                                    {
                                        Array(7).fill().map((_, index) => (
                                            <tr key={index}>
                                                <td><Skeleton width={150} height={50} /></td>
                                                <td><Skeleton width={100} height={50} /></td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                                :
                                <tbody>
                                    <tr>
                                        <td style={{ background: "#b9d8f9" }}>Customer Id</td>
                                        {
                                            view == "list" ?
                                                <td>{dataSet?.customerId || "-"}</td>
                                                :
                                                <td>
                                                    <input type="text" value={data?.customerId} style={customInputStyle} onChange={(e) => handleInput(e, "customerId")} />
                                                </td>
                                        }
                                    </tr>
                                    <tr>
                                        <td style={{ background: "#b9d8f9" }}>Finance Id</td>
                                        {
                                            view == "list" ?
                                                <td>{dataSet?.financeId || "-"}</td>
                                                :
                                                <td>
                                                    <input type="text" value={data?.financeId} style={customInputStyle} onChange={(e) => handleInput(e, "financeId")} />
                                                </td>
                                        }

                                    </tr>
                                    <tr>
                                        <td style={{ background: "#b9d8f9" }}>Agreement No</td>
                                        {
                                            view == "list" ?
                                                <td>{dataSet?.agreementNo || "-"}</td>
                                                :
                                                <td>
                                                    <input type="text" value={data?.agreementNo} style={customInputStyle} onChange={(e) => handleInput(e, "agreementNo")} />
                                                </td>
                                        }
                                    </tr>
                                    <tr>
                                        <td style={{ background: "#b9d8f9" }}>Status</td>
                                        {
                                            view == "list" ?
                                                <td>{dataSet?.status || "-"}</td>
                                                :
                                                <td>

                                                    <select value={data?.status} style={customInputStyle} onChange={(e) => handleInput(e, "status")}>
                                                        <option value={""}>Select Status</option>
                                                        <option value={"success"}>Success</option>
                                                        <option value={"failure"}>Failure</option>
                                                    </select>
                                                </td>
                                        }
                                    </tr>
                                    <tr>
                                        <td style={{ background: "#b9d8f9" }}>Stage</td>
                                        {
                                            view == "list" ?
                                                <td>{dataSet?.stage || "-"}</td>
                                                :
                                                <td>
                                                    
                                                     <select value={data?.stage} style={customInputStyle} onChange={(e) => handleInput(e, "stage")}>
                                                        <option value={""}>Select Stage</option>
                                                        <option value={"pushCustomerData"}>Push Customer Data</option>
                                                        <option value={"pushCustomerDocuments"}>Push Customer Documents</option>
                                                        <option value={"pushCustomerSelfie"}>Push Customer Selfie</option>
                                                        <option value={"pushCustomerCrif"}>Push Customer Crif</option>
                                                        <option value={"financeCreation"}>Finance Creation</option>
                                                    </select>
                                                </td>
                                        }
                                    </tr>
                                    <tr>
                                        <td style={{ background: "#b9d8f9" }}>Lead Detail Id</td>
                                        {
                                            view == "list" ?
                                                <td>{dataSet?.leadDetailId || "-"}</td>
                                                :
                                                <td>
                                                    <input type="text" value={data?.leadDetailId} style={customInputStyle} onChange={(e) => handleInput(e, "leadDetailId")} />
                                                </td>
                                        }
                                    </tr>
                                    <tr>
                                        <td style={{ background: "#b9d8f9" }}>Lead Index No</td>
                                        {
                                            view == "list" ?
                                                <td>{dataSet?.leadIndexNo || "-"}</td>
                                                :
                                                <td>
                                                    <input type="text" value={data?.leadIndexNo} style={customInputStyle} onChange={(e) => handleInput(e, "leadIndexNo")} />
                                                </td>
                                        }
                                    </tr>
                                    <tr>
                                        <td style={{ background: "#b9d8f9" }}>Added On</td>
                                        <td>{handleEmpty(dataSet?.addedOn) ? moment(dataSet?.addedOn).format("DD-MM-YYYY HH:MM:SS") : "-"}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ background: "#b9d8f9", borderBottomLeftRadius: '0px' }}>Updated On</td>
                                        <td>{handleEmpty(dataSet?.updatedOn) ? moment(dataSet?.updatedOn).format("DD-MM-YYYY HH:MM:SS") : "-"}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ background: "#b9d8f9", borderBottomLeftRadius: '0px' }}>Error</td>
                                       
                                        {
                                            view == "list" ?
                                                <td>{dataSet?.error || "-"}</td>
                                                :
                                                <td>
                                                    <input type="text" value={data?.error} style={customInputStyle} onChange={(e) => handleInput(e, "error")} />
                                                </td>
                                        }
                                    </tr>
                                </tbody>
                        }
                    </table>
                    {
                        view == "edit" ?
                            <div style={{ marginTop: '20px', textAlign: 'center' }}>
                                <button className="btn btn-primary" onClick={() => handleSave()}>Save</button>
                            </div>
                            : ""}
                </div>
            </div>
        </>
    );
}

export default ChecklistFresh;
